export default __webpack_public_path__ + "c101a732979e0550690b350627de2b6b.svg";